import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { androidContentOffset } from 'Theme/Theme';

const defaultStyles = {
    container: {
        paddingHorizontal: Theme.primaryMargin,
        marginTop: Device.isTabletOrWeb ? 2 : 0
    },
    note: {
        color: Theme.secondaryTextColor,
        marginHorizontal: Theme.primaryMargin / 2,
        marginTop: 10,
        lineHeight: 22
    }
};
defaultStyles.description = {
    ...defaultStyles.note,
    marginBottom: Theme.primaryMargin * 2,
    ...androidContentOffset
};

export default StyleSheet.create(defaultStyles);
